<footer class="footer d-flex flex-xl-row flex-column-reverse justify-content-between">
	<nav class="d-flex flex-column justify-content-between gap-5">
		<a
			class="fw-bold text-decoration-none text-nowrap d-none d-xl-inline-block"
			target="_blank"
			[href]="'sbb_footer_contactUs_link' | translate"
			>{{ 'sbb_footer_contactUs_text' | translate }}</a
		>
		<div>
			<ul class="list-unstyled d-flex justify-content-center
			 justify-content-sm-between justify-content-xl-start mb-0">
				<li>
					<a
					class="small text-decoration-none text-nowrap me-4 d-inline d-xl-none"
					target="_blank"
					[href]="'sbb_footer_contactUs_link' | translate"
					>{{ 'sbb_footer_contactUs_text' | translate }}</a
				>
			</li>
			<li>
                <a
				class="small text-decoration-none me-4"
				target="_blank"
				[href]="'sbb_footer_accessibility_link' | translate"
				>{{ 'sbb_footer_accessibility_text' | translate }}</a
			>
			</li>
			<li>
				<a
				class="small text-decoration-none me-4"
				target="_blank"
				[href]="'sbb_footer_legal_link' | translate"
				>{{ 'sbb_footer_legal_text' | translate }}</a
			>
			</li>
			<li>
				<a
				class="small text-decoration-none me-4"
				target="_blank"
				[href]="'sbb_footer_privacy_link' | translate"
				>{{ 'sbb_footer_privacy_text' | translate }}</a
			>
			</li>
			<li>
				<a
				class="small text-decoration-none"
				target="_blank"
				[href]="'sbb_footer_security_link' | translate"
				>{{ 'sbb_footer_security_text' | translate }}</a
			>
			</li>
		</ul>
		</div>
	</nav>
	<div class="d-flex flex-column justify-content-between pt-md-0 pt-3">
		<div class="d-flex flex-column flex-xl-row flex-grow-1 align-items-center align-items-xl-start">
			<a target="_blank" [href]="'sbb_footer_cdic_link' | translate">
				<img
					src="assets/img/third-party-logos/cdic.png"
					class="img-fluid me-3 mb-3 mb-md-0"
					[alt]="'sbb_footer_cdic_accessibility' | translate"
				/>
			</a>
			<p class="small" [innerHtml]="'sbb_footer_cdic' | translate"></p>
		</div>
		<p class="small mb-0 d-none d-xl-block">
			{{ 'sbb_footer_trademark' | translate }}
		</p>
	</div>
</footer>
